import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CautionOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m12 5.5 3.95 6.77 3.93 6.72H4.12l3.93-6.72L12 5.5Zm0-2.11c-.43 0-.85.2-1.09.6l-4.33 7.42-4.43 7.58c-.45.77.15 1.7 1.09 1.7h17.52c.94 0 1.53-.93 1.09-1.7l-4.43-7.58-4.33-7.42c-.23-.4-.66-.6-1.09-.6Z" />
      <Path d="M11.73 14.92c-.11-.1-.17-.25-.2-.43l-.56-3.38s-.01-.1-.01-.17c0-.33.11-.58.33-.77.22-.19.5-.28.83-.28.33 0 .62.09.84.28.22.19.33.45.33.77 0 .07 0 .13-.01.17l-.58 3.37c-.02.19-.09.33-.19.43-.11.1-.23.15-.39.15s-.28-.05-.39-.15v.01Zm-.37 2.44c-.2-.2-.3-.45-.3-.75s.1-.55.3-.75c.2-.2.45-.3.75-.3s.54.1.74.3c.2.2.3.45.3.75s-.1.55-.3.75c-.2.2-.45.3-.74.3s-.56-.1-.75-.3Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CautionOutlined
